import bem from 'utils/bem';

export const block = bem('editor-modal-transcription-options');
